import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  Tabs,
  Tab,
} from '@mui/material';
import { Close, History } from '@mui/icons-material';
import { useEffect, useState } from 'react';

import { AssuntosMonitoringPanel, AgenciesMonitoringPanel, KeywordsMonitoringPanel } from './monitoring';

export type MonitoringHistorySection = 'assuntos' | 'agencies' | 'keywords';

interface MonitoringHistoryDialogProps {
  open: boolean;
  onClose: () => void;
  initialSection?: MonitoringHistorySection;
}

/** Histórico unificado: assuntos, agências e palavras-chave. */
export function MonitoringHistoryDialog({
  open,
  onClose,
  initialSection = 'assuntos',
}: MonitoringHistoryDialogProps) {
  const [section, setSection] = useState<MonitoringHistorySection>(initialSection);

  useEffect(() => {
    if (open) {
      setSection(initialSection);
    }
  }, [open, initialSection]);

  const handleClose = () => {
    setSection('assuntos');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center" gap={1}>
            <History color="primary" />
            <Typography variant="h5" fontWeight={600}>
              Histórico de Monitoramento
            </Typography>
          </Box>
          <IconButton onClick={handleClose} size="small">
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        <Box sx={{ px: 3, pt: 2, borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={section}
            onChange={(_, value: MonitoringHistorySection) => setSection(value)}
            aria-label="Tipo de monitoramento"
          >
            <Tab label="Assuntos" value="assuntos" />
            <Tab label="Agências" value="agencies" />
            <Tab label="Palavra-chave" value="keywords" />
          </Tabs>
        </Box>

        <Box sx={{ px: 3, py: 2 }}>
          {section === 'assuntos' && <AssuntosMonitoringPanel enabled={open && section === 'assuntos'} />}
          {section === 'agencies' && <AgenciesMonitoringPanel enabled={open && section === 'agencies'} />}
          {section === 'keywords' && <KeywordsMonitoringPanel enabled={open && section === 'keywords'} />}
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={handleClose} variant="contained">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
